// Helpers de visita (OS)
//
// osLabel(visita) — usa voalle_protocolo como identificador principal pro operador,
// pois é o número que aparece no Voalle e no contato com o cliente.
// Fallback pro id interno (#i<id>) quando protocolo ainda não chegou
// pelo datalake (raro mas pode acontecer no momento de criação).

export function osLabel(visita) {
  if (!visita) return '';
  const proto = visita.voalle_protocolo;
  if (proto) return `#${proto}`;
  return `#i${visita.id}`;
}

// Variante que aceita só os 2 campos (útil quando você não tem o objeto completo)
export function osLabelByFields(protocolo, id) {
  if (protocolo) return `#${protocolo}`;
  if (id) return `#i${id}`;
  return '';
}

// Retorna emoji que representa o tipo de OS pelo nome
// Heurística: detecta palavra-chave em tipo_os (suporte, instalação, etc).
export function iconeTipoOs(tipoOs) {
  if (!tipoOs) return '🔧';
  const t = tipoOs.toLowerCase();
  if (t.includes('instala'))   return '🔌';
  if (t.includes('mudança') || t.includes('mudanca') || t.includes('migra')) return '📦';
  if (t.includes('retirad') || t.includes('recolh') || t.includes('cancel')) return '🗑️';
  if (t.includes('repar') || t.includes('defeito') || t.includes('atenu')) return '⚡';
  if (t.includes('vistoria') || t.includes('inspeç') || t.includes('inspec')) return '🔍';
  if (t.includes('upgrade') || t.includes('downgrade')) return '📊';
  if (t.includes('suport') || t.includes('manuten')) return '🔧';
  return '📋';
}

// Calcula diferença em minutos entre dois timestamps ISO.
export function diffMin(t1, t2) {
  if (!t1 || !t2) return null;
  return (new Date(t2) - new Date(t1)) / 60000;
}

// Formata duração em minutos como '2h 15min' / '47min' / '12s'
export function formatDuracaoMin(min) {
  if (min == null || isNaN(min)) return '—';
  const abs = Math.abs(min);
  if (abs < 1) return `${Math.round(abs * 60)}s`;
  if (abs < 60) return `${Math.round(abs)}min`;
  const h = Math.floor(abs / 60);
  const m = Math.round(abs % 60);
  return m > 0 ? `${h}h ${m}min` : `${h}h`;
}

// Monta texto resumido pra banner "N OS precisa(m) atenção · ..."
// Recebe array `atencao` do snapshot (cada item tem tipo + detalhes).
export function montarTextoAtencao(atencao = []) {
  if (atencao.length === 0) return null;
  const exemplos = atencao.slice(0, 3).map(a => {
    const proto = osLabelByFields(a.voalle_protocolo, a.visita_id);
    if (a.tipo === 'atrasada')       return `OS ${proto} (${a.tecnico_apelido || 'sem técnico'}) há ${a.minutos_atraso}min`;
    if (a.tipo === 'sem_tecnico')    return `OS ${proto} sem técnico`;
    if (a.tipo === 'tecnico_parado') return `${a.tecnico_apelido} parado próximo a visita`;
    return a.motivo || 'atenção';
  });
  return exemplos.join(' · ');
}
